import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const shape = {
  borderRadius: capitalDesignTokens.foundations.units.unitHalf
};
export {
  shape
};
//# sourceMappingURL=shape.js.map
